


















































































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { Borough, Clinic } from "@/model/Boroughs";
import ServiceInformation from "@/components/ServiceInformation.vue";
import CallbackForm from "@/components/CallbackForm.vue";
import { interpolateString } from "@/utils";
import { RiskLevelForScore, StringMap } from "@/model/Model";
import { RiskLevel } from "@/model/RiskLevel";
@Component({
  components: {
    ServiceInformation,
    CallbackForm
  }
})
export default class SupportOverview extends Vue {
  @Prop() public region!: Borough;
  @Prop() public score!: number;

  private get regionName(): string {
    return this.region.displayName || this.region.name;
  }

  @Emit("navigate")
  private handleNavigation(event: string) {
    return event;
  }

  private get bookingLiveLink(): string {
    switch (this.region.name) {
      case "West Sussex":
        return "https://drinkcoach.bookinglive.com/book/add/p/11";
      case "Suffolk":
        return "https://drinkcoach.bookinglive.com/book/add/p/29";
      case "Rotherham":
        return "https://drinkcoach.bookinglive.com/book/add/p/22";
      case "Essex":
        return "https://drinkcoach.bookinglive.com/book/add/p/24";
      case "Barnet":
        return "https://drinkcoach.bookinglive.com/book/add/p/14";
      case "Lambeth":
        return "https://drinkcoach.bookinglive.com/book/add/p/15";
      case "NorthEastAndNorthCumbria":
        return "https://drinkcoach.bookinglive.com/book/add/p/19";
      case "Staffordshire":
        return "https://drinkcoach.bookinglive.com/book/add/p/17";
      case "Lewisham":
        return "https://drinkcoach.bookinglive.com/book/add/p/16";
      case "Haringey":
        return "https://drinkcoach.bookinglive.com/book/add/p/20";
      case "Waltham Forest":
        return "https://drinkcoach.bookinglive.com/book/add/p/18";
      case "Barnsley":
        return "https://drinkcoach.bookinglive.com/book/add/p/13";
      case "Croydon":
        return "https://drinkcoach.bookinglive.com/book/add/p/31";
      case "Bradford District":
        return "https://drinkcoach.bookinglive.com/book/add/p/32";
      default:
        return "https://drinkcoach.bookinglive.com/";
    }
  }

  private get isHighRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.High;
  }

  private get primaryServiceDescription(): string {
    const primaryServiceProvider = this.primaryServiceProvider as Clinic;

    const description =
      primaryServiceProvider.description || primaryServiceProvider.name;
    // Does description need interpolation?
    if (description.indexOf("${") !== -1) {
      const regex = /\${([A-z]+)}/g;
      const map: StringMap<() => { label: string }> = {};
      // ts-lint:disable-next-line: no-conditional-assignment
      let match = regex.exec(description);
      while (match !== null) {
        if (match) {
          const matchVar: string = match[1] as string;
          map[matchVar] = () => ({
            label: primaryServiceProvider[matchVar] as string
          });
        }
        match = regex.exec(description);
      }
      return interpolateString(description, map);
    }
    return description;
  }

  private get primaryServicePhoneNumber(): string {
    const phone = (this.primaryServiceProvider as Clinic).phone;
    if (phone && phone.length) {
      return this.formatPhone(
        phone[0] as string | { title: string; value: string }
      );
    }
    return "";
  }

  private formatPhone(
    phone: string | { title: string; value: string }
  ): string {
    let p: string;
    if (typeof phone === "string") {
      p = phone;
    } else {
      p = phone.value;
    }
    return p.replace(/-/g, " ").replace(/ /g, "&nbsp;");
  }

  @Emit("navigate")
  private gotoSupportFinder(event: Event) {
    event.preventDefault();
    return "find-support";
  }

  private get primaryServiceProvider(): Clinic | null {
    if (this.region.clinics !== undefined) {
      const primaryClinic = this.primaryServiceProviders;
      if (primaryClinic.length) {
        return primaryClinic![0] as Clinic;
      } else {
        return this.region.clinics[0] as Clinic;
      }
    }
    return null;
  }

  private get primaryServiceProviders(): Clinic[] {
    if (this.region.clinics !== undefined) {
      const score = RiskLevelForScore(this.score);
      return (this.region.clinics as Clinic[]).filter(clinic =>
        (
          clinic.isPrimaryProvider &&
          (clinic.showAtRiskLevel === undefined ||
            (clinic.showAtRiskLevel as RiskLevel[]).includes(score))
        )
      );
    }
    return [];
  }
}
